export const TAG_TYPES = {
  MEAL: 'MEAL',
  PLAN: 'PLAN',
};
